import { SettingsPanel } from '@/components/Settings/SettingsPanel';
import { FormBuilder } from '@hogwarts/ui-components-forms';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const userPreferenceFields = ({
  organisations,
  timezones,
  languages,
  showPasswordFields,
}: {
  organisations: any[];
  timezones: any[];
  languages: any[];
  showPasswordFields: boolean;
}) => [
  {
    key: 'defaultDashboardId',
    type: 'textbox',
    label: 'Default Dashboard',
    readOnly: true,
    visible: false,
  },
  {
    key: 'firstname',
    type: 'textbox',
    label: 'First Name',
    validate: 'required',
    maxLength: 50,
  },
  {
    key: 'lastname',
    type: 'textbox',
    label: 'Last Name',
    validate: 'required',
    maxLength: 50,
  },
  {
    key: 'phone',
    type: 'textbox',
    label: 'Phone Number',
    maxLength: 20,
  },
  {
    key: 'defaultOrganisationKey',
    type: 'singleselect',
    label: 'Default Organisation',
    values: organisations,
    validate: 'required',
  },
  {
    key: 'defaultLanguageKey',
    type: 'singleselect',
    label: 'Interface Language',
    values: languages,
    validate: 'required',
  },
  {
    key: 'timezone',
    type: 'singleselect',
    label: 'Time Zone (for notifications)',
    values: timezones,
    validate: 'required',
  },
  ...(showPasswordFields
    ? ([
        {
          key: 'currentPassword',
          type: 'password',
          label: 'Current Password',
          meta: {
            disableShowPassword: false,
          },
        },
        {
          key: 'newPassword',
          type: 'password',
          label: 'New Password',
          meta: {
            disableShowPassword: false,
          },
        },
        {
          key: 'confirmPassword',
          type: 'password',
          label: 'Confirm New Password',
          meta: {
            disableShowPassword: false,
          },
        },
      ] as any[])
    : []),
];

interface Preferences {
  defaultDashboardId?: string;
  firstname?: string;
  lastname?: string;
  phone?: string;
  defaultOrganisationKey?: string;
  defaultLanguageKey?: string;
  timezone?: string;
  currentPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

interface UserPreferencesProps {
  firstname?: string;
  lastname?: string;
  languages: unknown[];
  organisations: unknown[];
  timezones: unknown[];
  preferences: Preferences;
  onSavePreferences: (values: any) => void;
  showPasswordFields: boolean;
}
export const UserPreferences = ({
  firstname,
  lastname,
  languages,
  organisations,
  timezones,
  preferences,
  onSavePreferences,
  showPasswordFields,
}: UserPreferencesProps) => {
  const { t } = useTranslation();
  const [values, setCurrentValues] = useState<Preferences>({
    firstname,
    lastname,
    ...preferences,
  });

  const actions = [
    {
      text: t('Save'),
      icon: 'save',
      disabled: false,
      intent: 'primary',
      onClick: () => onSavePreferences(values),
    },
  ];

  return (
    <SettingsPanel title={'User Preferences'} actions={actions}>
      <div style={{ padding: '10px' }} className="w-50">
        <FormBuilder
          initialValues={{
            firstname,
            lastname,
            ...preferences,
          }}
          fields={userPreferenceFields({
            organisations,
            timezones,
            languages,
            showPasswordFields,
          })}
          onValuesChanged={setCurrentValues}
        />
      </div>
    </SettingsPanel>
  );
};
